import * as zod from 'zod';

const movementActivity = zod.enum([
  'none',
  'requestingPlan',
  'planning',
  'receivingPlan',
  'moving',
  'paused',
]);

export const WeldVariables = zod.object({
  completedWeldCount: zod.number().int().nonnegative(),
  currentActivity: zod.enum([
    'approaching',
    'settingWeldParameters',
    'startArc',
    'movingDuringWeld',
    'movingToNextStitch',
    'craterFilling',
    'dwelling',
    'stopArc',
    'none',
  ]),
  // Keep these separate in order to distinguish movement during welding from approach.
  approachMovementActivity: movementActivity,
  weldMovementActivity: movementActivity,
  // Whether the stitch pattern *logically* expects welding to be on. This is
  // used to make pause/resume decisions in stitched welds so we don't
  // incorrectly restart the arc while moving through a "space" segment.
  weldOnResume: zod.boolean().default(false),
});

export type WeldVariables = zod.infer<typeof WeldVariables>;
